<template>
    <div class="borderChart" v-if="config.border.show">
        <div :style="{
            'border-width': `${config.border.width}px`,
            'border-style': `${config.border.style}`,
            'border-color': `${config.border.color}`,
            'border-radius': `${config.border.radius}px`,
            'border-image-slice': '100',
        }" v-if="config.border.index==='自定义'"></div>
        <div :style="{
            'border-image-source': `url('${list[config.border.index].img}')`,
            'border-width': `${config.border.width}px`,
            'border-image-slice': '100',
            'border-style': 'solid'
        }" v-else></div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/5/25 4:32 下午
     */
    import {borderList} from '../script/comChart'

    export default {
        name: 'borderChart',
        components: {},
        props: {
            id: {
                type: String,
                default: 0
            },
            option:{
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                list: borderList
            }
        },
        computed: {
            config() {
                return this.option.comConfig;
            },
        },
        methods: {},
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .borderChart {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        > div {
            width: 100%;
            height: 100%;
        }
    }
</style>